import React from 'react'
import authRouteRegex from './Auth/routeRegex'
import DynamicComponent from 'App/components/DynamicComponent'
import useRouter from 'App/hooks/useRouter'
import SuspenseLoading from 'App/components/SuspenseLoading'
import Home from './Home'
import Services from './Services'
import JustoTrack from './JustoTrack'
import Inbox from './Inbox'
import {Route, Switch} from 'react-router-dom'

const Auth = DynamicComponent(() => import('./Auth'))
const Admin = DynamicComponent(() => import('./Admin'))
const Operator = DynamicComponent(() => import('./Operator'))
const Zones = DynamicComponent(() => import('./Zones'))
const Drivers = DynamicComponent(() => import('./Drivers'))
const Finances = DynamicComponent(() => import('./Finances'))
const Promotions = DynamicComponent(() => import('./Promotions'))
const Alerts = DynamicComponent(() => import('./Alerts'))
const AlertsNew = DynamicComponent(() => import('./AlertsNew'))
const Areas = DynamicComponent(() => import('./Areas'))
const Content = DynamicComponent(() => import('./Content'))

function Page() {
  const {location} = useRouter()
  const {pathname} = location

  if (authRouteRegex.test(pathname)) {
    return <Auth />
  }

  if (pathname.startsWith('/admin')) {
    return <Admin />
  }

  if (pathname.startsWith('/operator')) {
    return <Operator />
  }

  if (pathname.startsWith('/contrato-de-transporte')) {
    window.location.href =
      'https://onedrive.live.com/view.aspx?resid=E51167F4A07D1DB6!25490&ithint=file%2cdocx&authkey=!AHE_Ds6kRfO6uM0'
    return null
  }

  if (pathname.startsWith('/alerts-new')) {
    return <AlertsNew />
  }

  if (pathname.startsWith('/alerts')) {
    return <Alerts />
  }

  if (pathname.startsWith('/finances')) {
    return <Finances />
  }

  if (pathname.startsWith('/promotions')) {
    return <Promotions />
  }

  if (pathname.startsWith('/zones')) {
    return <Zones />
  }

  if (pathname.startsWith('/drivers')) {
    return <Drivers />
  }

  if (pathname.startsWith('/areas')) {
    return <Areas />
  }

  if (pathname.startsWith('/content')) {
    return <Content />
  }

  if (pathname.startsWith('/services')) {
    return <Services />
  }

  if (pathname.startsWith('/justo-track')) {
    return <JustoTrack />
  }

  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/inbox" component={Inbox} />
    </Switch>
  )
}

export default function Pages() {
  return (
    <SuspenseLoading>
      <Page />
    </SuspenseLoading>
  )
}
